import {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useQueryClient} from "react-query";
import {useNavigate, useParams} from "react-router-dom";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import * as archiveFolderApi from "../../api/archiveApi/archiveFolderApi";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import SubTitle from "../../components/SubTitle";
import {useCreateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";
import {KPFolder, initializeFolder} from "../../models/serverModels/archive/KPFolder";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import FolderForm from "./FolderForm";

const CreateFolder = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: createMutate, isLoading} = useCreateMutation<ResponseItem<KPFolder>, any>({
    api: archiveFolderApi.create,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate(`/Archive/${id}`, {replace: true});
        queryClient.invalidateQueries("ArchiveList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });
  const methods = useForm<KPFolder>({
    defaultValues: initializeFolder(),
  });

  const {reset} = methods;

  const onSubmit: SubmitHandler<KPFolder> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initializeFolder(), ...data, folderUID: parseInt(id!)},
    });
  };
  useEffect(() => {
    reset();
  }, [reset]);
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="폴더 추가" />
      {isLoading && <MWProgress />}

      <FormSection>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <FolderForm />
          <ConfirmButtonGroup link={`/Archive/${id}`} cancelText="취소" confirmText="저장" />
        </form>
      </FormSection>
    </FormProvider>
  );
};
export default CreateFolder;
